import { personDataSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { CCOnboardingEditableFields } from 'components/features/creditCard/creditCardStore/types'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { ComponentProps, FC, ReactNode, useCallback, useMemo } from 'react'
import { EditInPlace } from 'components/features/creditCard/creditCardOnboarding/EditInPlace/EditInPlace'
import { PatchCCOnboardingPropsAction } from 'components/features/creditCard/creditCardStore/actions'
import { QAMarked } from 'interfaces/component'

type InPlacePropEditorProps = QAMarked & {
  label: ReactNode
  name: CCOnboardingEditableFields
  className?: string
  mask?: (string | RegExp)[]
  transformBefore?: (value: string) => string
  transformAfter?: (value: string) => string
  maskValue?: (value: string) => string
  validationSchema?: ComponentProps<typeof EditInPlace>['validationSchema']
  maxLength?: number
  submitOnBlur?: boolean
}
export const InPlacePropEditor: FC<InPlacePropEditorProps> = (props) => {
  const { className, label, name, mask, maskValue, transformAfter, transformBefore, qaMarker, validationSchema, maxLength, submitOnBlur } = props

  const prevCCPersonData = useStoreSelector(personDataSelector)
  const initialValue = useMemo(() => {
    const propValue = prevCCPersonData ? `${ prevCCPersonData[name] }` : ''
    if (transformBefore) {
      return transformBefore(propValue)
    }
    return propValue
  }, [name, prevCCPersonData, transformBefore])

  const isLoading = useStoreSelector((state) => {
    const { patchOnboardingPropsRequest } = state.app.creditCard
    return patchOnboardingPropsRequest.isLoading && !!patchOnboardingPropsRequest.data && !!patchOnboardingPropsRequest.data[name]
  })
  const error = useStoreSelector((state) => {
    const { initiateRequest, patchOnboardingPropsRequest } = state.app.creditCard
    const personDataErrors = patchOnboardingPropsRequest?.errorsMap?.person_data as any || initiateRequest?.errorsMap?.person_data
    if (personDataErrors && personDataErrors[name] && personDataErrors[name][0]) {
      return personDataErrors[name][0]
    }

    return null
  })
  const dispatch = useStoreDispatch()
  const handleChange = useCallback((value: string) => {
    if (!value || initialValue === value) {
      return
    }

    dispatch(new PatchCCOnboardingPropsAction({
      step: 'review',
      person_data: {
        [name]: transformAfter ? transformAfter(value) : value,
      },
    }))

  }, [dispatch, initialValue, name, transformAfter])

  if (!prevCCPersonData) {
    return null
  }

  return (
    <EditInPlace
      className={ className }
      label={ label }
      error={ error }
      value={ initialValue }
      isLoading={ isLoading }
      mask={ mask }
      maskValue={ maskValue }
      onChange={ handleChange }
      qaMarker={ qaMarker }
      validationSchema={ validationSchema }
      maxLength={ maxLength }
      submitOnBlur={ submitOnBlur }
    />
  )
}
